import { useState, useEffect } from 'react'

const getFullscreenContainer = () => {
  if (typeof document === 'undefined') {
    return null
  }

  return document.fullscreenElement || document.body
}

/**
 * Returns the current fullscreen element (or document.body when not in fullscreen).
 * Use this as the `container` / popper `container` prop on MUI portals (Autocomplete,
 * Select, Popover, DatePicker …) so they remain visible inside a fullscreen element.
 */
export function useFullscreenContainer() {
  const [container, setContainer] = useState(getFullscreenContainer)

  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined
    }

    const handler = () => setContainer(getFullscreenContainer())
    document.addEventListener('fullscreenchange', handler)
    return () => document.removeEventListener('fullscreenchange', handler)
  }, [])

  return container
}
